import * as React from 'react';
import DropViewState from 'owa-dnd/lib/store/schema/DropViewState';
import { getDraggedItemType } from 'owa-module-dnd-store';
import { observer } from 'mobx-react';

export interface ListOrDropHintProps {
    dropViewState: DropViewState;
    dropHintView: JSX.Element;
    dragItem: string;
    coverChildren: boolean;
    showDropHint?: boolean;
}

@observer
export default class ListOrDropHint extends React.Component<ListOrDropHintProps, {}> {
    render() {
        if (!this.shouldShowDropHint()) {
            return this.props.children ? this.props.children : null;
        }
        return this.props.coverChildren ? (
            this.props.dropHintView
        ) : (
            <>
                {this.props.dropHintView}
                {this.props.children}
            </>
        );
    }

    private shouldShowDropHint = (): boolean => {
        /**
         * getDraggedItemType() will tell us the item being dragged across the hosted module,
         * e.g. email in mail module.
         * Once the dragged email crosses out of the mail module bonudary, onDragLeave of the mail module
         * sets draggedItemType to null.
         * However, now, it enters the My Day panel. So our dropState will have the itemType of the item being dragged.
         */
        const draggedItemType = getDraggedItemType();
        return (
            this.shouldShowDropHintForItemType(draggedItemType, this.props.dragItem) ||
            this.shouldShowDropHintForItemType(
                this.props.dropViewState.draggableItemType,
                this.props.dragItem
            ) ||
            this.props.showDropHint
        );
    };

    private shouldShowDropHintForItemType(draggedItemType: string, typeToDrag: string): boolean {
        return draggedItemType === typeToDrag;
    }
}
